import React from "react";
import styled from "styled-components";
// import home from "assets/home.png";

import home from "assets/oakmont/Picture1.jpg";
import play from "assets/play.png";
import Navbar from "./Navbar";
import { motion } from "framer-motion";
import { homeAnimation, homeInfoAnimation } from "animation";

import Typewriter from "typewriter-effect";
import { lightblue, yellow } from "./color";

function Home() {
  return (
    <Section id="home">
      <Navbar />
      <motion.div
        className="home"
        variants={homeAnimation}
        transition={{ delay: 0.3, duration: 0.6, type: "tween" }}
      >
        <div className="content">
          <div className="title">
            <h1>Welcome to </h1>
            <Title>
              <Typewriter
                options={{
                  autoStart: true,
                  loop: true,
                  cursor: "",
                }}
                onInit={(typewriter) => {
                  typewriter
                    .typeString(`<span class="text-1">OAKMONT</span>`)
                    .pauseFor(2000)
                    .deleteAll()
                    .typeString(`<span class="text-2">OAKMONT</span>`)
                    .pauseFor(2000)
                    .deleteAll()
                    // .typeString(`<span class="text-3">OAKMONT</span>`)
                    // .pauseFor(2000)
                    // .deleteAll()
                    // .typeString(`<span class="text-3">Dr.Man Ha</span>`)
                    // .pauseFor(2000)
                    // .deleteAll()
                    .start();
                }}
              />
            </Title>
          </div>

          <div className="subTitle">
            <p className="topSub">
              Oakmont has been set up to help you build a property portfolio.
            </p>
            <p className="topSub">
              We find the most profitable investment builds and pass them on to
              you!
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="info"
        variants={homeInfoAnimation}
        transition={{ delay: 0.3, duration: 0.6, type: "tween" }}
      >
        <div className="grid">
          <div className="col">
            <strong>OAKMONT</strong>
          </div>
          <div className="col">
            <strong>Email</strong>
            <p>info@oakmont.co.nz</p>
          </div>
          <div className="col">
            <strong>Phone</strong>
            <p>Mike on 021 881 444</p>
          </div>
          <div className="col">
            <strong>Privacy Policy</strong>
            <p>
              <a
                href="/policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: yellow }}
              >
                Open
              </a>
            </p>
          </div>
        </div>
      </motion.div>
    </Section>
  );
}

const Section = styled.section`
  background: url(${home}) repeat 000px 80px;
  backgound-color: #000;
  min-height: 100vh;
  background-size: cover;
  position: relative;
  .home {
    margin: auto 0;
    height: 95vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: justify-between;
      width: 100%;
      color: #fff;
      gap: 0rem;
      margin-top: -10rem;
      padding-left: 0rem;
      .title {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-right: 8rem;
        h1 {
          font-size: 3em;
          line-height: 5.3rem;
        }
      }
      .subTitle {
        border-left: 6px solid #f1f1f1;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: space-between; /* Ensures top and bottom p align with border */
        align-items: stretch; /* Expands content to match height */
        padding-left: 2rem;
        min-height: 100%; /* Ensures full height for proper alignment */
        gap: 4rem;

        p {
          font-size: 1.2rem;
          color: ${yellow};
          margin: 0; /* Remove unnecessary margins */
          text-align: left;
        }
      }
    }
  }
  .info {
    position: absolute;
    bottom: 0rem;
    right: 0;
    background-color: var(--secondary-color);
    padding: 4rem;
    font-size: 1.5rem;
    .grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 4rem;
      color: #fff;
      .col {
        .link {
          pointer: cursor;
          text-decoration: none;
          color: white;
        }
      }
    }
  }
  @media screen and (min-width: 280px) and (max-width: 1080px) {
    background: url(${home}) no-repeat center center;
    background-size: cover; /* Ensures full coverage */
    height: 100vh;
    width: 100%;
    .home {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh; /* Ensures it takes full height */
      padding-bottom: 5rem; /* Space for .info section */

      .content {
        flex-direction: column;
        margin-top: -10rem;
        padding-left: 0rem !important;
        margin-left: 0rem;
        .title {
          align-items: flex-start;
          margin-right: 5rem;
          h1 {
            width: 250%;
            font-size: 1.2rem;
            line-height: 1rem;
            font-weight: 300;
          }
        }
        .subTitle {
          margin: 1rem;
          border-left: none;

          width: 80%;
          justify-content: flex-start;
          flex-direction: column;
          padding-left: 0rem;
          gap: 0rem;
          p {
            width: 100%;
            font-size: 1.2rem;
            text-align: left;
            margin-left: 0rem;
            margin: 1rem;
          }
        }
      }
    }
    .info {
      position: initial;
      background-color: var(--secondary-color);
      margin-top: -15rem;
      width: 100%;
      padding: 2rem;
      font-size: 1.2rem;
      z-index: -1; /* Ensures it stays behind the nav menu */
      .grid {
        grid-template-columns: 1fr;
        gap: 1.2rem;
      }
    }
  }

  @media screen and (min-width: 1081px) and (max-width: 1366px) {
    .home {
      .content {
        margin-top: 4rem;
        padding-left: 12rem;
        .title {
          align-items: flex-start;
          margin-right: 5rem;
          h1 {
            width: 100%;
            font-size: 2rem;
            line-height: 1rem;
          }
        }
      }
    }
    .info {
      position: initial;
      bottom: 0rem;
    }
  }
`;

const Title = styled.h2`
  font-size: 5rem;
  text-transform: capitalize;
  width: 50%;
  color: white;
  align-self: flex-end;
  margin-right: 4rem;

  span {
    text-transform: uppercase;
  }
  .text-1 {
    color: ${lightblue};
  }
  .text-2 {
    color: ${yellow};
  }
  .text-3 {
    color: ${lightblue};
  }

  @media (max-width: 70em) {
    font-size: 3rem;
  }
  @media (max-width: 48em) {
    align-self: left;
    text-align: left;
  }
  @media (max-width: 40em) {
    width: 100%;
    font-size: 3rem;
    align-self: flex-start;
  }
`;

export default Home;
